(function(window, mL_config) {
    'use strict';

    window.mL_events = window.mL_events || {};

    var messages = {},
        lastUid = -1,
        ALL_SUBSCRIBING_MSG = '*';

    function hasKeys(obj) {
        var key;

        for (key in obj) {
            if (obj.hasOwnProperty(key)) {
                return true;
            }
        }
        return false;
    }

    function throwException(ex) {
        return function reThrowException() {
            throw ex;
        };
    }

    function callSubscriberWithDelayedExceptions(subscriber, message, data) {
        try {
            subscriber(message, data);
        } catch (ex) {
            setTimeout(throwException(ex), 0);
        }
    }

    function callSubscriberWithImmediateExceptions(subscriber, message, data) {
        subscriber(message, data);
    }

    function deliverMessage(originalMessage, matchedMessage, data, immediateExceptions) {
        var subscribers = messages[matchedMessage],
            callSubscriber = immediateExceptions ? callSubscriberWithImmediateExceptions : callSubscriberWithDelayedExceptions,
            s;

        if (!messages.hasOwnProperty(matchedMessage)) {
            return;
        }

        for (s in subscribers) {
            if (subscribers.hasOwnProperty(s)) {
                callSubscriber(subscribers[s], originalMessage, data);
            }
        }
    }

    function createDeliveryFunction(message, data, immediateExceptions) {
        return function deliverNamespaced() {
            var topic = String(message),
                position = topic.lastIndexOf('.');

            // deliver the message as it is now
            deliverMessage(message, message, data, immediateExceptions);

            // trim the hierarchy and deliver message to each level
            while (position !== -1) {
                topic = topic.substr(0, position);
                position = topic.lastIndexOf('.');
                deliverMessage(message, topic, data, immediateExceptions);
            }

            deliverMessage(message, ALL_SUBSCRIBING_MSG, data, immediateExceptions);
        };
    }

    function hasDirectSubscribersFor(message) {
        var topic = String(message),
            found = Boolean(messages.hasOwnProperty(topic) && hasKeys(messages[topic]));

        return found;
    }

    function messageHasSubscribers(message) {
        var topic = String(message),
            found = hasDirectSubscribersFor(topic) || hasDirectSubscribersFor(ALL_SUBSCRIBING_MSG),
            position = topic.lastIndexOf('.');

        while (!found && position !== -1) {
            topic = topic.substr(0, position);
            position = topic.lastIndexOf('.');
            found = hasDirectSubscribersFor(topic);
        }

        return found;
    }

    function publish(message, data, sync, immediateExceptions) {
        message = (typeof message === 'symbol') ? message.toString() : message;

        var deliver = createDeliveryFunction(message, data, immediateExceptions),
            hasSubscribers = messageHasSubscribers(message);

        if (!hasSubscribers) {
            return false;
        }

        if (sync === true) {
            deliver();
        } else {
            setTimeout(deliver, 0);
        }
        return true;
    }

    window.mL_events.publish = function(message, data) {
        return publish(message, data, false, window.mL_events.immediateExceptions);
    };

    window.mL_events.publishSync = function(message, data) {
        return publish(message, data, true, window.mL_events.immediateExceptions);
    };

    window.mL_events.subscribe = function(message, func) {
        if (typeof func !== 'function') {
            return false;
        }

        message = (typeof message === 'symbol') ? message.toString() : message;

        if (!messages.hasOwnProperty(message)) {
            messages[message] = {};
        }

        var token = 'uid_' + String(++lastUid);
        messages[message][token] = func;


        return token;
    };

    window.mL_events.subscribeAll = function(func) {
        return window.mL_events.subscribe(ALL_SUBSCRIBING_MSG, func);
    };

    window.mL_events.subscribeOnce = function(message, func) {
        var token = window.mL_events.subscribe(message, function() {
            // before func apply, unsubscribe message
            window.mL_events.unsubscribe(token);
            func.apply(this, arguments);
        });
        return window.mL_events;
    };

    window.mL_events.clearAllSubscriptions = function clearAllSubscriptions() {
        messages = {};
    };

    window.mL_events.clearSubscriptions = function clearSubscriptions(topic) {
        var m;
        for (m in messages) {
            if (messages.hasOwnProperty(m) && m.indexOf(topic) === 0) {
                delete messages[m];
            }
        }
    };

    window.mL_events.countSubscriptions = function countSubscriptions(topic) {
        var m;
        var count = 0;
        for (m in messages) {
            if (messages.hasOwnProperty(m) && m.indexOf(topic) === 0) {
                count++;
            }
        }
        return count;
    };

    window.mL_events.getSubscriptions = function getSubscriptions(topic) {
        var m;
        var list = [];
        for (m in messages) {
            if (messages.hasOwnProperty(m) && m.indexOf(topic) === 0) {
                list.push(m);
            }
        }
        return list;
    };


    window.mL_events.unsubscribe = function(value) {
        var descendantTopicExists = function(topic) {
                var m;
                for (m in messages) {
                    if (messages.hasOwnProperty(m) && m.indexOf(topic) === 0) {
                        // a descendant of the topic exists:
                        return true;
                    }
                }

                return false;
            },
            isTopic = typeof value === 'string' && (messages.hasOwnProperty(value) || descendantTopicExists(value)),
            isToken = !isTopic && typeof value === 'string',
            isFunction = typeof value === 'function',
            result = false,
            m, message, t;

        if (isTopic) {
            window.mL_events.clearSubscriptions(value);
            return;
        }

        for (m in messages) {
            if (messages.hasOwnProperty(m)) {
                message = messages[m];

                if (isToken && message[value]) {
                    delete message[value];
                    result = value;
                    // tokens are unique, so we can just stop here
                    break;
                }

                if (isFunction) {
                    for (t in message) {
                        if (message.hasOwnProperty(t) && message[t] === value) {
                            delete message[t];
                            result = true;
                        }
                    }
                }
            }
        }

        return result;
    };

    function init_debug() {
        var topics = ['page', 'cart', 'order', 'user', 'error', 'form', 'action'];
        var i = 0,
            l = topics.length;

        function add_subscriber(topic) {
            window.mL_events.subscribe(topic, function(msg, data) {
                console.log('------------------ DEBUG - TOPIC - ' + msg + ' - BEGINS');
                console.log(data);
                console.log('------------------ DEBUG - TOPIC - ' + msg + ' - ENDS');
            });
        }
        for (i; i < l; i += 1) {
            add_subscriber(topics[i]);
        }
    }

    if (mL_config.DEBUG) init_debug();

}(window, window.mL_config));